import {Pipe, PipeTransform} from '@angular/core';
import {enumParse} from './enum-parse.pipe';

/**
 * This pipe handles parsing of enumeration array.
 */
@Pipe({
  name: 'enumArrayParse',
})
export class EnumArrayParsePipe implements PipeTransform {

  /**
   * Transforms enumeration array to string value.
   * @example
   * // returns 'Monday, Friday'
   * transform([DayOfWeek.MONDAY, DayOfWeek.FRIDAY])
   * @example
   * // returns 'None'
   * transform([])
   * @param value an array of enumeration items.
   */
  transform(value: string[]) {
    if (!value) {
      return;
    }
    if (value.length === 0) {
      return 'None';
    }
    return value.map(item => enumParse(item)).join(', ');
  }
}
